import React from 'react'
import AdminLogin from '../../Components/Admin/AdminLogin/AdminLogin'

function LoginPage() {
  return (
    <div>
      <AdminLogin/>
    </div>
  )
}

export default LoginPage
